import { patchRequest } from '@/core';
import { goodsTypes } from '@/requests';

export default async function updateGoodsTypeRequest(id, patch) {
	let url = goodsTypes.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}